import { CenterAlignedLoader, Text } from '@medly-components/core';
import styled from 'styled-components';

export const PathSelectionModal = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(67, 84, 101, 0.3);
    z-index: 2;
    cursor: pointer;
`;

export const PathSelectionContent = styled.div<{ scale: number }>`
    overflow: hidden;
    display: flex;
    width: max-content;
    justify-content: space-between;
    position: relative;
    padding: ${({ scale }) => `min(${12 / scale}px, 12px)`};
    gap: ${({ scale }) => `min(${12 / scale}px, 12px)`};
    background: ${({ theme }) => theme.colors.white};
    border-radius: 0.4rem;
`;

export const PathSelectionOptionWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 0.8rem 1.6rem;
    cursor: pointer;
`;

export const PathSelectionOptionText = styled(Text)`
    padding-left: 2.8rem;
`;

export const Loader = styled(CenterAlignedLoader)`
    position: fixed;
    top: 0;
    left: 0;
    cursor: progress;
    background: rgba(67, 84, 101, 0.5);
`;
